package ui.components


import js.objects.jso
import react.*
import react.dom.html.ReactHTML.i
import react.FC
import react.Props
import react.dom.svg.ReactSVG.path
import react.dom.svg.ReactSVG.svg
import web.cssom.ClassName
import web.cssom.rem

// Icon Components
val DashboardIcon = FC<Props> {
    svg {
        className = ClassName("w-6 h-6")
        viewBox = "0 0 18 18"
        fill = "none"
        xmlns = "http://www.w3.org/2000/svg"

        path {
            d = "M4 14H6V9H4V14ZM12 14H14V4H12V14ZM8 14H10V11H8V14ZM8 9H10V7H8V9ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V2H2V16Z"
            fill = "#7F161B"
        }
    }
}

val ListingsIcon = FC<Props> {
    svg {
        className = ClassName("w-6 h-6")
        viewBox = "0 0 18 14"
        fill = "none"
        xmlns = "http://www.w3.org/2000/svg"

        path {
            d = "M0.0250244 12V2C0.0250244 1.45 0.220858 0.979167 0.612524 0.5875C1.00419 0.195833 1.47502 0 2.02502 0H16C16.55 0 17.0209 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V12C18 12.55 17.8042 13.0208 17.4125 13.4125C17.0209 13.8042 16.55 14 16 14H2.02502C1.47502 14 1.00419 13.8042 0.612524 13.4125C0.220858 13.0208 0.0250244 12.55 0.0250244 12ZM2.00002 12H5.32502V2H2.00002V12ZM7.32502 12H10.65V2H7.32502V12ZM12.65 12H15.975V2H12.65V12Z"
            fill = "#7F161B"
        }
    }
}

val OwnerSubmissionsIcon = FC<Props> {
    svg {
        className = ClassName("w-6 h-6")
        viewBox = "0 0 19 18"
        fill = "none"
        xmlns = "http://www.w3.org/2000/svg"

        path {
            d = "M2 16V2V6.475V6V16ZM4 10H9.525C9.55833 9.63333 9.64167 9.28333 9.775 8.95C9.90833 8.61667 10.075 8.3 10.275 8H4V10ZM4 14H7.925C8.20833 13.6667 8.53333 13.3958 8.9 13.1875C9.26667 12.9792 9.65 12.8083 10.05 12.675C9.98333 12.575 9.925 12.4667 9.875 12.35C9.825 12.2333 9.78333 12.1167 9.75 12H4V14ZM4 6H14V4H4V6ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V8.45C17.7667 8.01667 17.4833 7.63333 17.15 7.3C16.8167 6.96667 16.4333 6.69167 16 6.475V2H2V16H7.05C7.03333 16.1 7.02083 16.2 7.0125 16.3C7.00417 16.4 7 16.5 7 16.6V18H2ZM14 13C13.3 13 12.7083 12.7583 12.225 12.275C11.7417 11.7917 11.5 11.2 11.5 10.5C11.5 9.8 11.7417 9.20833 12.225 8.725C12.7083 8.24167 13.3 8 14 8C14.7 8 15.2917 8.24167 15.775 8.725C16.2583 9.20833 16.5 9.8 16.5 10.5C16.5 11.2 16.2583 11.7917 15.775 12.275C15.2917 12.7583 14.7 13 14 13ZM9 18V16.6C9 16.2 9.10417 15.8292 9.3125 15.4875C9.52083 15.1458 9.81667 14.9 10.2 14.75C10.8 14.5 11.4208 14.3125 12.0625 14.1875C12.7042 14.0625 13.35 14 14 14C14.65 14 15.2958 14.0625 15.9375 14.1875C16.5792 14.3125 17.2 14.5 17.8 14.75C18.1833 14.9 18.4792 15.1458 18.6875 15.4875C18.8958 15.8292 19 16.2 19 16.6V18H9Z"
            fill = "#7F161B"
        }
    }
}

val InquiriesIcon = FC<Props> {
    svg {
        className = ClassName("w-6 h-6")
        viewBox = "0 0 18 21"
        fill = "none"
        xmlns = "http://www.w3.org/2000/svg"

        path {
            d = "M8.9 15C9.25 15 9.54583 14.8792 9.7875 14.6375C10.0292 14.3958 10.15 14.1 10.15 13.75C10.15 13.4 10.0292 13.1042 9.7875 12.8625C9.54583 12.6208 9.25 12.5 8.9 12.5C8.55 12.5 8.25417 12.6208 8.0125 12.8625C7.77083 13.1042 7.65 13.4 7.65 13.75C7.65 14.1 7.77083 14.3958 8.0125 14.6375C8.25417 14.8792 8.55 15 8.9 15ZM8 11.15H9.85C9.85 10.8667 9.8625 10.625 9.8875 10.425C9.9125 10.225 9.96667 10.0333 10.05 9.85C10.1333 9.66667 10.2375 9.49583 10.3625 9.3375C10.4875 9.17917 10.6667 8.98333 10.9 8.75C11.4833 8.16667 11.8958 7.67917 12.1375 7.2875C12.3792 6.89583 12.5 6.45 12.5 5.95C12.5 5.06667 12.2 4.35417 11.6 3.8125C11 3.27083 10.1917 3 9.175 3C8.25833 3 7.47917 3.225 6.8375 3.675C6.19583 4.125 5.75 4.75 5.5 5.55L7.15 6.2C7.26667 5.75 7.5 5.3875 7.85 5.1125C8.2 4.8375 8.60833 4.7 9.075 4.7C9.525 4.7 9.9 4.82083 10.2 5.0625C10.5 5.30417 10.65 5.625 10.65 6.025C10.65 6.30833 10.5583 6.60833 10.375 6.925C10.1917 7.24167 9.88333 7.59167 9.45 7.975C9.16667 8.20833 8.9375 8.4375 8.7625 8.6625C8.5875 8.8875 8.44167 9.125 8.325 9.375C8.20833 9.625 8.125 9.8875 8.075 10.1625C8.025 10.4375 8 10.7667 8 11.15ZM9 21L6 18H2C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H12L9 21ZM2 16H6.8L9 18.2L11.2 16H16V2H2V16Z"
            fill = "#7F161B"
        }
    }
}

val StaticContentIcon = FC<Props> {
    svg {
        className = ClassName("w-6 h-6")
        viewBox = "0 0 18 18"
        fill = "none"
        xmlns = "http://www.w3.org/2000/svg"

        path {
            d = "M4 14H11V12H4V14ZM4 10H14V8H4V10ZM4 6H14V4H4V6ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V2H2V16Z"
            fill = "#7F161B"
        }
    }
}

val ScheduleIcon = FC<Props> {
    svg {
        className = ClassName("w-6 h-6")
        viewBox = "0 0 18 20"
        fill = "none"
        xmlns = "http://www.w3.org/2000/svg"

        path {
            d = "M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6ZM9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16Z"
            fill = "#7F161B"
        }
    }
}

val MenuIcon = FC<Props> {
    svg {
        className = ClassName("w-6 h-6")
        viewBox = "0 0 24 24"
        fill = "none"
        xmlns = "http://www.w3.org/2000/svg"

        path {
            d = "M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z"
            fill = "#ffffff"
        }
    }
}

val CloseIcon = FC<Props> {
    svg {
        className = ClassName("w-6 h-6")
        viewBox = "0 0 24 24"
        fill = "none"
        xmlns = "http://www.w3.org/2000/svg"

        path {
            d = "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
            fill = "#ffffff"
        }
    }
}

// External interface for icon props
external interface IconProps : Props {
    var className: String?
}

// ShieldPersonIcon Component
val ShieldPersonIcon = FC<IconProps> { props ->
    i {
        className = ClassName("bi bi-shield-check ${props.className ?: "w-6 h-6"}")
        style = jso {
            fontSize = 1.5.rem
        }
    }
}

// SettingsIcon Component
val SettingsIcon = FC<IconProps> { props ->
    i {
        className = ClassName("bi bi-gear ${props.className ?: "w-6 h-6"}")
        style = jso {
            fontSize = 1.5.rem
        }
    }
}

// ErrorIcon Component
val ErrorIcon = FC<IconProps> { props ->
    i {
        className = ClassName("bi bi-exclamation-circle-fill ${props.className ?: "w-3 h-3"}")
        style = jso {
            fontSize = 0.75.rem
        }
    }
}